const PICTIONARY_WORDS = [
  // Simple objects (easy to draw)
  'apple', 'backpack', 'banana', 'book', 'candle',
  'chair', 'cup', 'door', 'glasses', 'hat',
  'key', 'lamp', 'pencil', 'shoe', 'table',

  // Animals (good from original list)
  'elephant', 'butterfly', 'penguin', 'kangaroo', 'dinosaur',
  'dolphin', 'giraffe', 'octopus', 'flamingo', 'starfish',
  'tiger', 'walrus', 'bee', 'cat', 'dog',
  'frog', 'horse', 'lion', 'mouse', 'owl',
  
  // Food items (easy to draw)
  'pizza', 'hamburger', 'ice cream', 'hot dog', 'cookie',
  'cake', 'donut', 'popcorn', 'sandwich', 'sushi',
  
  // Places/structures (good from original list)
  'castle', 'lighthouse', 'pyramid', 'igloo', 'treehouse',
  'skyscraper', 'bridge', 'tent', 'farm', 'cave',
  
  // Transportation (drawable)
  'bicycle', 'helicopter', 'sailboat', 'submarine', 'airplane',
  'bus', 'car', 'train', 'rocket', 'truck',
  
  // Nature (good visuals)
  'mountain', 'rainbow', 'sunflower', 'waterfall', 'volcano',
  'beach', 'cactus', 'forest', 'island', 'moon',
  
  // People/characters (easy to draw)
  'astronaut', 'pirate', 'wizard', 'robot', 'snowman',
  'baby', 'chef', 'doctor', 'firefighter', 'ninja',
  
  // Clothing/accessories
  'crown', 'sunglasses', 'umbrella', 'boots', 'necklace',
  'scarf', 'tie', 'watch', 'belt', 'gloves',
  
  // Sports/activities
  'basketball', 'fishing', 'swimming', 'bowling', 'skiing',
  'soccer', 'tennis', 'yoga', 'baseball', 'golf',
  
  // Household items
  'toaster', 'television', 'mirror', 'clock', 'couch',
  'refrigerator', 'toilet', 'shower', 'bed', 'desk',
  
  // Instruments (from original)
  'guitar', 'xylophone', 'drum', 'piano', 'trumpet',
  
  // Fun whimsical (but drawable) items
  'unicorn', 'dragon', 'mermaid', 'ghost', 'alien',
  'treasure', 'fairy', 'zombie', 'vampire', 'werewolf',
  
  // Additional simple objects
  'balloon', 'brush', 'button', 'camera', 'coin',
  'envelope', 'fence', 'flashlight', 'hammer', 'kite',
  'ladder', 'magnet', 'nail', 'paperclip', 'scissors',
  'spoon', 'thumb', 'tissue', 'toothbrush', 'zipper',
  
  // Additional animals
  'bat', 'camel', 'crab', 'deer', 'fox',
  'hippo', 'koala', 'lobster', 'monkey', 'panda',
  'parrot', 'peacock', 'pig', 'polar bear', 'raccoon',
  'seal', 'shark', 'sheep', 'sloth', 'snail',
  
  // Additional food items
  'apple pie', 'broccoli', 'cheese', 'chicken', 'corn',
  'cupcake', 'lollipop', 'noodles', 'pineapple', 'pretzel',
  
  // Additional places/structures
  'airport', 'barn', 'factory', 'hospital', 'library',
  'lighthouse', 'mall', 'museum', 'school', 'windmill',
  
  // Additional nature
  'campfire', 'cloud', 'flower', 'palm tree', 'river',
  'snowflake', 'star', 'sun', 'tornado', 'wave',
  
  // Additional people/characters
  'clown', 'cowboy', 'knight', 'mummy', 'princess',
  'scarecrow', 'skier', 'superhero', 'witch', 'zombie',
  
  // Activities and sports
  'archery', 'camping', 'dancing', 'diving', 'hiking',
  'jumping rope', 'karate', 'painting', 'skateboarding', 'surfing',
  
  // Tools and equipment
  'anchor', 'axe', 'compass', 'drill', 'fishing rod',
  'microscope', 'ruler', 'slingshot', 'wrench',
  
  // Electronics and technology
  'calculator', 'drone', 'headphones', 'keyboard', 'laptop',
  'microphone', 'printer', 'robot', 'smartphone', 'video game',
  
  // Miscellaneous drawable items
  'bubble', 'cactus', 'ferris wheel', 'fireworks', 'gravestone',
  'hot air balloon', 'maze', 'nest', 'puzzle', 'seesaw',
  'swing', 'telescope', 'thermometer', 'traffic light', 'whistle',
  
  // Weather and natural phenomena
  'blizzard', 'earthquake', 'eclipse', 'flood', 'hurricane',
  'lightning', 'meteor', 'quicksand', 'sandstorm', 'tsunami',
  
  // Body parts and actions
  'elbow', 'eyebrow', 'fingerprint', 'footprint', 'handshake',
  'heartbeat', 'hiccup', 'knee', 'sneeze', 'wink',
  
  // Emotions and expressions
 'excitement', 'fear', 'happiness',
'laughter', 'sadness', 'surprise', 'worry',
  
  // Abstract concepts (moderately drawable)
  'balance', 'gravity', 'growth', 'memory', 'patience',
  'progress', 'reflection', 'strength', 'teamwork', 'victory',
  
  // Professions and occupations
  'architect', 'barber', 'carpenter', 'dentist', 'electrician',
  'farmer', 'gardener', 'judge', 'librarian', 'mechanic',
  'photographer', 'plumber', 'teacher', 'veterinarian', 'waiter',
  
  // Games and toys
  'checkers', 'chess', 'dominoes', 'frisbee', 'hopscotch',
  'jigsaw puzzle', 'jump rope', 'marbles', 'monopoly', 'slinky',
  'deck of cards', 'dice', 'spinning top',
  
  // Kitchen and cooking
  'blender', 'colander', 'cutting board', 'frying pan', 'grater',
  'ladle', 'mixer', 'oven mitt', 'rolling pin', 'spatula',
  'strainer', 'tongs', 'whisk', 'apron', 'recipe',
  
  // School and office supplies
  'binder', 'calculator', 'eraser', 'highlighter', 'marker',
  'notebook', 'paperclip', 'ruler', 'stapler', 'tape',
  'thumbtack', 'whiteboard', 'folder', 'backpack', 'locker',
  
  // Garden and plants
  'fertilizer', 'greenhouse', 'hose', 'lawn mower', 'rake',
  'seed', 'shovel', 'sprinkler', 'watering can', 'weed',
  'compost', 'mulch', 'pruning shears', 'garden gnome', 'bird bath',
  
  // Medical and health
  'bandage', 'crutches', 'first aid kit', 'medicine', 'stethoscope',
  'syringe', 'thermometer', 'wheelchair', 'hospital bed',
  
  // Celebrations and holidays
  'birthday cake', 'candles', 'confetti', 'gift wrap', 'party hat',
  'streamers', 'balloons', 'champagne', 'fireworks', 'graduation cap',
  
  // Transportation parts
  'antenna', 'bumper', 'exhaust pipe', 'headlight', 'horn',
  'license plate', 'rearview mirror', 'seatbelt', 'steering wheel', 'tire',
  
  // Building and construction
  'blueprint', 'cement', 'crane', 'hard hat', 'ladder',
  'nail', 'paint brush', 'scaffolding', 'toolbox', 'wrench',
  
  // Fabric and clothing materials
  'button', 'fabric', 'needle', 'pattern', 'pin',
  'scissors', 'sewing machine', 'thread', 'zipper', 'yarn',
  
  // Communication and media
  'antenna', 'broadcast', 'email', 'newspaper', 'radio',
  'satellite', 'signal', 'speaker', 'television', 'wifi'
];

export default PICTIONARY_WORDS; 